// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../public//image/icon/check.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../public/image/icon/boxSelectArrow.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "utf-8";

/* checkbox */
.mediaCart_checkbox_label__dTXk2 {
  width: 16px;
  height: 16px;
  background-color: #fff;
  border: 1px solid #efefef;
}

.mediaCart_checkbox__OYx2A:checked+label .mediaCart_checkbox_label__dTXk2 {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) #fff no-repeat center / contain;
}

.mediaCart_check_group__-jr-O {
  display: flex;
  align-items: center;
  gap: 20px;
  padding-left: 9px;
  width: 181px;
}

/* input */
.mediaCart_text_input__84GZc,
.mediaCart_textarea__sP0Rk {
  outline: none;
  border: none;
  background-color: transparent;
  width: 100%;
  padding-left: 0;
  font-size: 15px;
}

.mediaCart_text_input__84GZc::placeholder,
.mediaCart_textarea__sP0Rk::placeholder {
  color: #c2c2c2;
  font-size: 15px;
  line-height: 170%;
}

.mediaCart_request_wrapper_pt__3lcCU {
  padding-top: 15.5px;
  padding-bottom: 15.5px;
  background-color: #efefef;
}

.mediaCart_request_wrapper__cKl6U {
  /* margin-top: 15.5px; */
  padding: 0 21.5px 10px;
  background-color: #efefef;
  height: 403px;
  /* overflow-y: auto; */
}

.mediaCart_request_wrapper__cKl6U::-webkit-scrollbar-track {
  background-color: #fff;
}

.mediaCart_textarea__sP0Rk {
  height: auto;
  resize: none;
}

/* table */
.mediaCart_table__rm6wi {
  margin-bottom: 5.75px;
  min-width: 1157px !important;
}

.mediaCart_table__rm6wi> :not(caption)>*>* {
  padding: 0;
}

.mediaCart_table__rm6wi th.mediaCart_table_th__ABAe3 {
  padding: 14.89px 0 7.5px;
  font-size: 13px;
}

.mediaCart_table__rm6wi .mediaCart_tableSticky__PRZHH,
.mediaCart_table__rm6wi th.mediaCart_table_th__ABAe3 {
  position: sticky;
  left: -1px;
  z-index: 9;
}

.mediaCart_tableResponsive__2IB16 {
  position: relative;
}

.mediaCart_table__rm6wi .mediaCart_bg_dark_gray__4WPE\\+ {
  text-align: center;
  background-color: #bfbfbf;
  padding-top: 17.89px;
  padding-bottom: 12.11px;
  font-size: 13px;
}

.mediaCart_table__rm6wi .mediaCart_mobileBookingWrapper__TZeom {
  transform: rotate(0);
  height: 70px;
}

.mediaCart_table__rm6wi .mediaCart_mobileBooking__StUf7 {
  left: 0;
  top: 16px;
  position: absolute;
}

/* progress bar */

.mediaCart_bgMain__BhM07>div {
  background-color: #971b4d;
}

.mediaCart_bgMain__BhM07.mediaCart_progress__VqFXT {
  --bs-progress-bg: #fbe5d6;
  --bs-progress-height: 19.5px;
  border-radius: 0;
}

.mediaCart_cartTitle__2pZfi {
  display: flex;
  align-items: center;
  gap: 9px;
  padding-top: 5px;
}

.mediaCart_cartWrapper__0mIij {
  padding-left: 24px;
  padding-right: 27px;
  padding-bottom: 50px;
  /* height: calc(100vh - 108px); */
  height: calc((var(--vh, 1vh) * 100) - 108px);
  overflow: auto;
}

.mediaCart_w_114px__mNQBg {
  width: 114px;
}

.mediaCart_fs_9px__GQUTv {
  font-size: 9px;
}

.mediaCart_fs_10px__Uhcpp {
  font-size: 10px;
}

.mediaCart_fs_12px__dkg78 {
  font-size: 12px;
}

.mediaCart_fs_13px__Qu3xL {
  font-size: 13px;
}

.mediaCart_pfs_22px__RKYJV {
  font-size: 22.5px;
}

.mediaCart_pfs_27px__qcAXP {
  font-size: 27.5px;
}

.mediaCart_gap_22px__w6AYk {
  gap: 22px;
}

.mediaCart_ppy_8px__d3Olo {
  padding-top: 8.5px !important;
  padding-bottom: 8.5px !important;
}

.mediaCart_pps_7px__8Pf6X {
  padding-left: 7.5px;
}

.mediaCart_ppt_9px__8PrYb {
  padding-top: 9.5px;
}

.mediaCart_py_11px__orh4T {
  padding-top: 11px;
  padding-bottom: 11px;
}

.mediaCart_ppy_11_25px__hOUOC {
  padding-top: 11.25px;
  padding-bottom: 11.25px;
}

.mediaCart_ppy_12_5px__-3VLP {
  padding-top: 12px;
  padding-bottom: 12.5px;
}

.mediaCart_ppt_13px__2Nmhs {
  padding-top: 13.5px;
}

.mediaCart_w_66px__N0CA- {
  width: 66px;
}

.mediaCart_w_77px__-C-cv {
  width: 77px;
}

.mediaCart_w_104px__28P2f {
  width: 104px;
}

.mediaCart_w_106px__1axy5 {
  width: 106px;
}

.mediaCart_w_202px__eUll4 {
  max-width: 202px;
  min-width: 202px;
}

.mediaCart_text_gray__J2xYb {
  color: #868686;
}

.mediaCart_new_line_pt1__RAd64 {
  padding-top: 15.5px;
}

.mediaCart_new_line_pt2__ncm4g {
  padding-top: 12.5px;
}

.mediaCart_custom_select_arrow__NDeup {
  width: 14.5px;
  height: 14.5px;
  background-color: #f2f2f2;
  padding: 0 3px;
  margin-right: 2.5px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.mediaCart_custom_date_arrow__Jbo8X {
  width: 14.5px;
  height: 14.5px;
  background-color: #f2f2f2;
  right: 0;
  top: 50%;
  margin-right: 2.5px;
  transform: translateY(-40%);
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
}

.mediaCart_date_picker__HTW3z {
  font-size: 9px;
  text-align: center;
  border: none;
  font-weight: 700;
  padding: 5px 0;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) no-repeat #fff 97%;
}

.mediaCart_date_picker__HTW3z:focus {
  border: 0;
}

.mediaCart_date_picker_wrapper__CRZMY {
  padding-right: 11px !important;
  padding-left: 11px !important;
}

.mediaCart_requestButton__x6tqr {
  padding: 9.89px 29.5px 9.61px;
  font-size: 17px;
  font-weight: 700;
  margin-left: 110.5px;
}

.mediaCart_mobileRequestButton__zNbaG {
  margin-left: 5vw;
  padding: 7px 10.5px 7px;
  font-weight: 700;
  font-size: 14px;
}

.mediaCart_booking_text__iR1qT {
  color: #961d4c;
  font-size: 22.5px;
  font-weight: 800;
  padding-top: 29px;
}

.mediaCart_booking_info__A0Ggt {
  font-size: 12px;
  font-weight: 400;
  line-height: 170%;
  padding-top: 7.86px;
}

.mediaCart_requst_title__LbBZo {
  font-size: 15px;
  font-weight: 800;
  line-height: 170%;
}

.mediaCart_attached_plan_wrapper__azdIv {
  background-color: #f2f2f2;
  padding-top: 8px;
  padding-left: 26px;
  padding-bottom: 12px;
}

.mediaCart_modal_list__XSpOM {
  text-align: center;
  font-size: 12px;
  padding: 5px 0;
  cursor: pointer;
}

.mediaCart_modal_list__XSpOM:hover {
  background-color: #dddddd;
}

.mediaCart_media_icon__\\+m7FT {
  width: 36px;
  height: 36px;
}

.mediaCart_plan_gap__Yuse9 {
  gap: 20px;
  align-items: center;
}

.mediaCart_plan_list_wrapper__9eVxZ {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 6px;
}

.mediaCart_plan_list__iD93P {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  justify-content: center;
}

.mediaCart_booking_button_wrapper__LoJox {
  padding-top: 8px;
  display: flex;
  gap: 8px;
}

.mediaCart_attached_file_list__uFB2N {
  margin-left: 8px;
  display: flex;
  align-items: center;
  gap: 16px;
  font-size: 12px;
  font-weight: 800;
  flex-wrap: wrap;
}

.mediaCart_lh_170__FCqQc {
  line-height: 170%;
}

.mediaCart_cartTableWrapper__eu6zv {
  padding-top: 25px;
  padding-bottom: 25px;
  gap: 92px;
}

.mediaCart_hover_underline__BW23r:hover {
  text-decoration: underline;
}

.mediaCart_bookingCancel__zPjEJ {
  padding: 4px 13px;
  font-size: 12px;
  font-weight: 700;
  background-color: #bbbbbb;
  transition: 0.2s;
}

.mediaCart_bookingCancel__zPjEJ:hover {
  background-color: #767676;
}

.mediaCart_numericFormat__NDlpE {
  border: none;
  cursor: pointer;
  color: #000;
  background-color: transparent;
  outline: none;
  caret-color: transparent;
  pointer-events: none;
  display: block;
  /* width: 145px; */
}

.mediaCart_mobileBookingButton__WIPFF {
  text-align: center;
  white-space: nowrap;
  width: 114px;
}

@media (max-width: 1679px) {
  .mediaCart_main_container__OxKuY {
    width: calc(100% - 225px);
  }

  .mediaCart_tableResponsive__2IB16 {
    width: calc(100vw - 294px);
  }
}

@media (max-width: 1500px) {
  .mediaCart_tableResponsive__2IB16 {
    width: calc(100vw - 283px);
    overflow: auto;
  }

  .mediaCart_mobileBookingWrapper__TZeom {
    width: calc(100vw - 283px);
  }

  .mediaCart_table__rm6wi {
    margin-bottom: 0;
  }
}

/* @media (max-width: 1439px) {
  .tableResponsive {
    width: calc(100vw - 317px);
    overflow: auto;
  }
} */

@media (max-width: 1280px) {

  .mediaCart_tableResponsive__2IB16,
  .mediaCart_mobileBookingWrapper__TZeom {
    width: calc(95.3vw);
  }

  .mediaCart_cartWrapper__0mIij {
    width: 100vw;
    padding-left: 24px;
    padding-right: 24px;
    padding-bottom: 80px;
  }

  .mediaCart_cartTableWrapper__eu6zv {
    padding-top: 15px;
    padding-bottom: 15px;
    gap: 42px;
  }

  .mediaCart_booking_text__iR1qT {
    font-size: 16px;
  }

  .mediaCart_booking_info__A0Ggt {
    font-size: 10px;
  }

  .mediaCart_requst_title__LbBZo {
    font-size: 11px;
  }

  .mediaCart_textarea__sP0Rk,
  .mediaCart_text_input__84GZc,
  .mediaCart_textarea__sP0Rk::placeholder,
  .mediaCart_text_input__84GZc::placeholder {
    font-size: 11px;
  }

  .mediaCart_request_wrapper_pt__3lcCU {
    padding-top: 10px;
    padding-bottom: 10px;
  }

  .mediaCart_request_wrapper__cKl6U {
    padding-left: 10px;
    padding-right: 10px;
  }

  .mediaCart_booking_button_wrapper__LoJox {
    flex-direction: column;
  }

  .mediaCart_attached_file_list__uFB2N {
    gap: 8px;
  }

  .mediaCart_requestButton__x6tqr {
    font-size: 13px;
  }
}

@media (max-width: 768px) {

  .mediaCart_plan_gap__Yuse9 {
    gap: 10px;
  }

  .mediaCart_cartTitle__2pZfi {
    gap: 0;
    padding-top: 17px;
  }

  .mediaCart_tableResponsive__2IB16,
  .mediaCart_mobileBookingWrapper__TZeom {
    width: calc(100vw - 30px);
  }

  .mediaCart_table__rm6wi th.mediaCart_table_th__ABAe3 {
    padding-bottom: 6.5px;
  }

  .mediaCart_media_icon__\\+m7FT {
    width: 20px;
    height: 20px;
  }

  .mediaCart_fs_13px__Qu3xL {
    font-size: 10px;
  }

  .mediaCart_pfs_22px__RKYJV {
    font-size: 16px;
  }

  .mediaCart_pfs_27px__qcAXP {
    font-size: 19px;
  }

  .mediaCart_gap_22px__w6AYk {
    gap: 10px;
  }

  .mediaCart_cartWrapper__0mIij {
    padding-right: 13px;
    padding-left: 13px;
    padding-bottom: 50px;
  }

  .mediaCart_plan_list__iD93P {
    /* flex-direction: column; */
    gap: 4px;
  }

  .mediaCart_ppy_11_25px__hOUOC {
    padding-top: 9px;
    padding-bottom: 10px;
  }

  .mediaCart_ppy_12_5px__-3VLP {
    padding-top: 11px;
    padding-bottom: 11.5px;
  }

  .mediaCart_w_66px__N0CA-,
  .mediaCart_w_104px__28P2f {
    width: auto;
  }

  .mediaCart_new_line_pt1__RAd64 {
    padding-top: 13px;
  }

  .mediaCart_new_line_pt2__ncm4g {
    padding-top: 9px;
  }
}

@media (max-width: 500px) {
  .mediaCart_mobileBookingButton__WIPFF {
    width: auto;
  }

  .mediaCart_numericFormat__NDlpE {
    font-size: 14px;
  }
}

@media (max-width:1629px) {
  .mediaCart_selected_new_width__qnCIA {
    max-width: 115px;
  }
}

@media (max-width:1600px) {
  .mediaCart_selected_new_width__qnCIA {
    max-width: 110px;
  }
}

@media (max-width:1500px) {
  .mediaCart_selected_new_width__qnCIA {
    max-width: 105px;
  }
}`, "",{"version":3,"sources":["webpack://./src/css/mediaCart.module.css"],"names":[],"mappings":"AAAA,gBAAgB;;AAEhB,aAAa;AACb;EACE,WAAW;EACX,YAAY;EACZ,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,mFAAmF;AACrF;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,iBAAiB;EACjB,YAAY;AACd;;AAEA,UAAU;AACV;;EAEE,aAAa;EACb,YAAY;EACZ,6BAA6B;EAC7B,WAAW;EACX,eAAe;EACf,eAAe;AACjB;;AAEA;;EAEE,cAAc;EACd,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,wBAAwB;EACxB,sBAAsB;EACtB,yBAAyB;EACzB,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,YAAY;EACZ,YAAY;AACd;;AAEA,UAAU;AACV;EACE,qBAAqB;EACrB,4BAA4B;AAC9B;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,wBAAwB;EACxB,eAAe;AACjB;;AAEA;;EAEE,gBAAgB;EAChB,UAAU;EACV,UAAU;AACZ;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,oBAAoB;EACpB,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,YAAY;AACd;;AAEA;EACE,OAAO;EACP,SAAS;EACT,kBAAkB;AACpB;;AAEA,iBAAiB;;AAEjB;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,oBAAoB;EACpB,iCAAiC;EACjC,4CAA4C;EAC5C,cAAc;AAChB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,6BAA6B;EAC7B,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;EACE,oBAAoB;EACpB,uBAAuB;AACzB;;AAEA;EACE,iBAAiB;EACjB,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,cAAc;EACd,yBAAyB;EACzB,cAAc;EACd,mBAAmB;EACnB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,cAAc;EACd,yBAAyB;EACzB,QAAQ;EACR,QAAQ;EACR,mBAAmB;EACnB,2BAA2B;EAC3B,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,YAAY;EACZ,gBAAgB;EAChB,cAAc;EACd,sEAA8E;AAChF;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,8BAA8B;EAC9B,6BAA6B;AAC/B;;AAEA;EACE,6BAA6B;EAC7B,eAAe;EACf,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,gBAAgB;EAChB,uBAAuB;EACvB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;EACR,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,oBAAoB;EACpB,SAAS;AACX;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,WAAW;EACX,6BAA6B;EAC7B,aAAa;EACb,wBAAwB;EACxB,oBAAoB;EACpB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE;IACE,yBAAyB;EAC3B;;EAEA;IACE,0BAA0B;EAC5B;AACF;;AAEA;EACE;IACE,0BAA0B;IAC1B,cAAc;EAChB;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,gBAAgB;EAClB;AACF;;AAEA;;;;;GAKG;;AAEH;;EAEE;;IAEE,mBAAmB;EACrB;;EAEA;IACE,YAAY;IACZ,kBAAkB;IAClB,mBAAmB;IACnB,oBAAoB;EACtB;;EAEA;IACE,iBAAiB;IACjB,oBAAoB;IACpB,SAAS;EACX;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;;;;IAIE,eAAe;EACjB;;EAEA;IACE,iBAAiB;IACjB,oBAAoB;EACtB;;EAEA;IACE,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,QAAQ;EACV;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA;;EAEE;IACE,SAAS;EACX;;EAEA;IACE,MAAM;IACN,iBAAiB;EACnB;;EAEA;;IAEE,yBAAyB;EAC3B;;EAEA;IACE,qBAAqB;EACvB;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,mBAAmB;IACnB,kBAAkB;IAClB,oBAAoB;EACtB;;EAEA;IACE,4BAA4B;IAC5B,QAAQ;EACV;;EAEA;IACE,gBAAgB;IAChB,oBAAoB;EACtB;;EAEA;IACE,iBAAiB;IACjB,sBAAsB;EACxB;;EAEA;;IAEE,WAAW;EACb;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,WAAW;EACb;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,gBAAgB;EAClB;AACF","sourcesContent":["@charset \"utf-8\";\n\n/* checkbox */\n.checkbox_label {\n  width: 16px;\n  height: 16px;\n  background-color: #fff;\n  border: 1px solid #efefef;\n}\n\n.checkbox:checked+label .checkbox_label {\n  background: url(../../public//image/icon/check.svg) #fff no-repeat center / contain;\n}\n\n.check_group {\n  display: flex;\n  align-items: center;\n  gap: 20px;\n  padding-left: 9px;\n  width: 181px;\n}\n\n/* input */\n.text_input,\n.textarea {\n  outline: none;\n  border: none;\n  background-color: transparent;\n  width: 100%;\n  padding-left: 0;\n  font-size: 15px;\n}\n\n.text_input::placeholder,\n.textarea::placeholder {\n  color: #c2c2c2;\n  font-size: 15px;\n  line-height: 170%;\n}\n\n.request_wrapper_pt {\n  padding-top: 15.5px;\n  padding-bottom: 15.5px;\n  background-color: #efefef;\n}\n\n.request_wrapper {\n  /* margin-top: 15.5px; */\n  padding: 0 21.5px 10px;\n  background-color: #efefef;\n  height: 403px;\n  /* overflow-y: auto; */\n}\n\n.request_wrapper::-webkit-scrollbar-track {\n  background-color: #fff;\n}\n\n.textarea {\n  height: auto;\n  resize: none;\n}\n\n/* table */\n.table {\n  margin-bottom: 5.75px;\n  min-width: 1157px !important;\n}\n\n.table> :not(caption)>*>* {\n  padding: 0;\n}\n\n.table th.table_th {\n  padding: 14.89px 0 7.5px;\n  font-size: 13px;\n}\n\n.table .tableSticky,\n.table th.table_th {\n  position: sticky;\n  left: -1px;\n  z-index: 9;\n}\n\n.tableResponsive {\n  position: relative;\n}\n\n.table .bg_dark_gray {\n  text-align: center;\n  background-color: #bfbfbf;\n  padding-top: 17.89px;\n  padding-bottom: 12.11px;\n  font-size: 13px;\n}\n\n.table .mobileBookingWrapper {\n  transform: rotate(0);\n  height: 70px;\n}\n\n.table .mobileBooking {\n  left: 0;\n  top: 16px;\n  position: absolute;\n}\n\n/* progress bar */\n\n.bgMain>div {\n  background-color: #971b4d;\n}\n\n.bgMain.progress {\n  --bs-progress-bg: #fbe5d6;\n  --bs-progress-height: 19.5px;\n  border-radius: 0;\n}\n\n.cartTitle {\n  display: flex;\n  align-items: center;\n  gap: 9px;\n  padding-top: 5px;\n}\n\n.cartWrapper {\n  padding-left: 24px;\n  padding-right: 27px;\n  padding-bottom: 50px;\n  /* height: calc(100vh - 108px); */\n  height: calc((var(--vh, 1vh) * 100) - 108px);\n  overflow: auto;\n}\n\n.w_114px {\n  width: 114px;\n}\n\n.fs_9px {\n  font-size: 9px;\n}\n\n.fs_10px {\n  font-size: 10px;\n}\n\n.fs_12px {\n  font-size: 12px;\n}\n\n.fs_13px {\n  font-size: 13px;\n}\n\n.pfs_22px {\n  font-size: 22.5px;\n}\n\n.pfs_27px {\n  font-size: 27.5px;\n}\n\n.gap_22px {\n  gap: 22px;\n}\n\n.ppy_8px {\n  padding-top: 8.5px !important;\n  padding-bottom: 8.5px !important;\n}\n\n.pps_7px {\n  padding-left: 7.5px;\n}\n\n.ppt_9px {\n  padding-top: 9.5px;\n}\n\n.py_11px {\n  padding-top: 11px;\n  padding-bottom: 11px;\n}\n\n.ppy_11_25px {\n  padding-top: 11.25px;\n  padding-bottom: 11.25px;\n}\n\n.ppy_12_5px {\n  padding-top: 12px;\n  padding-bottom: 12.5px;\n}\n\n.ppt_13px {\n  padding-top: 13.5px;\n}\n\n.w_66px {\n  width: 66px;\n}\n\n.w_77px {\n  width: 77px;\n}\n\n.w_104px {\n  width: 104px;\n}\n\n.w_106px {\n  width: 106px;\n}\n\n.w_202px {\n  max-width: 202px;\n  min-width: 202px;\n}\n\n.text_gray {\n  color: #868686;\n}\n\n.new_line_pt1 {\n  padding-top: 15.5px;\n}\n\n.new_line_pt2 {\n  padding-top: 12.5px;\n}\n\n.custom_select_arrow {\n  width: 14.5px;\n  height: 14.5px;\n  background-color: #f2f2f2;\n  padding: 0 3px;\n  margin-right: 2.5px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.custom_date_arrow {\n  width: 14.5px;\n  height: 14.5px;\n  background-color: #f2f2f2;\n  right: 0;\n  top: 50%;\n  margin-right: 2.5px;\n  transform: translateY(-40%);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  cursor: pointer;\n}\n\n.date_picker {\n  font-size: 9px;\n  text-align: center;\n  border: none;\n  font-weight: 700;\n  padding: 5px 0;\n  background: url(../../public/image/icon/boxSelectArrow.svg) no-repeat #fff 97%;\n}\n\n.date_picker:focus {\n  border: 0;\n}\n\n.date_picker_wrapper {\n  padding-right: 11px !important;\n  padding-left: 11px !important;\n}\n\n.requestButton {\n  padding: 9.89px 29.5px 9.61px;\n  font-size: 17px;\n  font-weight: 700;\n  margin-left: 110.5px;\n}\n\n.mobileRequestButton {\n  margin-left: 5vw;\n  padding: 7px 10.5px 7px;\n  font-weight: 700;\n  font-size: 14px;\n}\n\n.booking_text {\n  color: #961d4c;\n  font-size: 22.5px;\n  font-weight: 800;\n  padding-top: 29px;\n}\n\n.booking_info {\n  font-size: 12px;\n  font-weight: 400;\n  line-height: 170%;\n  padding-top: 7.86px;\n}\n\n.requst_title {\n  font-size: 15px;\n  font-weight: 800;\n  line-height: 170%;\n}\n\n.attached_plan_wrapper {\n  background-color: #f2f2f2;\n  padding-top: 8px;\n  padding-left: 26px;\n  padding-bottom: 12px;\n}\n\n.modal_list {\n  text-align: center;\n  font-size: 12px;\n  padding: 5px 0;\n  cursor: pointer;\n}\n\n.modal_list:hover {\n  background-color: #dddddd;\n}\n\n.media_icon {\n  width: 36px;\n  height: 36px;\n}\n\n.plan_gap {\n  gap: 20px;\n  align-items: center;\n}\n\n.plan_list_wrapper {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 6px;\n}\n\n.plan_list {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 8px;\n  justify-content: center;\n}\n\n.booking_button_wrapper {\n  padding-top: 8px;\n  display: flex;\n  gap: 8px;\n}\n\n.attached_file_list {\n  margin-left: 8px;\n  display: flex;\n  align-items: center;\n  gap: 16px;\n  font-size: 12px;\n  font-weight: 800;\n  flex-wrap: wrap;\n}\n\n.lh_170 {\n  line-height: 170%;\n}\n\n.cartTableWrapper {\n  padding-top: 25px;\n  padding-bottom: 25px;\n  gap: 92px;\n}\n\n.hover_underline:hover {\n  text-decoration: underline;\n}\n\n.bookingCancel {\n  padding: 4px 13px;\n  font-size: 12px;\n  font-weight: 700;\n  background-color: #bbbbbb;\n  transition: 0.2s;\n}\n\n.bookingCancel:hover {\n  background-color: #767676;\n}\n\n.numericFormat {\n  border: none;\n  cursor: pointer;\n  color: #000;\n  background-color: transparent;\n  outline: none;\n  caret-color: transparent;\n  pointer-events: none;\n  display: block;\n  /* width: 145px; */\n}\n\n.mobileBookingButton {\n  text-align: center;\n  white-space: nowrap;\n  width: 114px;\n}\n\n@media (max-width: 1679px) {\n  .main_container {\n    width: calc(100% - 225px);\n  }\n\n  .tableResponsive {\n    width: calc(100vw - 294px);\n  }\n}\n\n@media (max-width: 1500px) {\n  .tableResponsive {\n    width: calc(100vw - 283px);\n    overflow: auto;\n  }\n\n  .mobileBookingWrapper {\n    width: calc(100vw - 283px);\n  }\n\n  .table {\n    margin-bottom: 0;\n  }\n}\n\n/* @media (max-width: 1439px) {\n  .tableResponsive {\n    width: calc(100vw - 317px);\n    overflow: auto;\n  }\n} */\n\n@media (max-width: 1280px) {\n\n  .tableResponsive,\n  .mobileBookingWrapper {\n    width: calc(95.3vw);\n  }\n\n  .cartWrapper {\n    width: 100vw;\n    padding-left: 24px;\n    padding-right: 24px;\n    padding-bottom: 80px;\n  }\n\n  .cartTableWrapper {\n    padding-top: 15px;\n    padding-bottom: 15px;\n    gap: 42px;\n  }\n\n  .booking_text {\n    font-size: 16px;\n  }\n\n  .booking_info {\n    font-size: 10px;\n  }\n\n  .requst_title {\n    font-size: 11px;\n  }\n\n  .textarea,\n  .text_input,\n  .textarea::placeholder,\n  .text_input::placeholder {\n    font-size: 11px;\n  }\n\n  .request_wrapper_pt {\n    padding-top: 10px;\n    padding-bottom: 10px;\n  }\n\n  .request_wrapper {\n    padding-left: 10px;\n    padding-right: 10px;\n  }\n\n  .booking_button_wrapper {\n    flex-direction: column;\n  }\n\n  .attached_file_list {\n    gap: 8px;\n  }\n\n  .requestButton {\n    font-size: 13px;\n  }\n}\n\n@media (max-width: 768px) {\n\n  .plan_gap {\n    gap: 10px;\n  }\n\n  .cartTitle {\n    gap: 0;\n    padding-top: 17px;\n  }\n\n  .tableResponsive,\n  .mobileBookingWrapper {\n    width: calc(100vw - 30px);\n  }\n\n  .table th.table_th {\n    padding-bottom: 6.5px;\n  }\n\n  .media_icon {\n    width: 20px;\n    height: 20px;\n  }\n\n  .fs_13px {\n    font-size: 10px;\n  }\n\n  .pfs_22px {\n    font-size: 16px;\n  }\n\n  .pfs_27px {\n    font-size: 19px;\n  }\n\n  .gap_22px {\n    gap: 10px;\n  }\n\n  .cartWrapper {\n    padding-right: 13px;\n    padding-left: 13px;\n    padding-bottom: 50px;\n  }\n\n  .plan_list {\n    /* flex-direction: column; */\n    gap: 4px;\n  }\n\n  .ppy_11_25px {\n    padding-top: 9px;\n    padding-bottom: 10px;\n  }\n\n  .ppy_12_5px {\n    padding-top: 11px;\n    padding-bottom: 11.5px;\n  }\n\n  .w_66px,\n  .w_104px {\n    width: auto;\n  }\n\n  .new_line_pt1 {\n    padding-top: 13px;\n  }\n\n  .new_line_pt2 {\n    padding-top: 9px;\n  }\n}\n\n@media (max-width: 500px) {\n  .mobileBookingButton {\n    width: auto;\n  }\n\n  .numericFormat {\n    font-size: 14px;\n  }\n}\n\n@media (max-width:1629px) {\n  .selected_new_width {\n    max-width: 115px;\n  }\n}\n\n@media (max-width:1600px) {\n  .selected_new_width {\n    max-width: 110px;\n  }\n}\n\n@media (max-width:1500px) {\n  .selected_new_width {\n    max-width: 105px;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"checkbox_label": `mediaCart_checkbox_label__dTXk2`,
	"checkbox": `mediaCart_checkbox__OYx2A`,
	"check_group": `mediaCart_check_group__-jr-O`,
	"text_input": `mediaCart_text_input__84GZc`,
	"textarea": `mediaCart_textarea__sP0Rk`,
	"request_wrapper_pt": `mediaCart_request_wrapper_pt__3lcCU`,
	"request_wrapper": `mediaCart_request_wrapper__cKl6U`,
	"table": `mediaCart_table__rm6wi`,
	"table_th": `mediaCart_table_th__ABAe3`,
	"tableSticky": `mediaCart_tableSticky__PRZHH`,
	"tableResponsive": `mediaCart_tableResponsive__2IB16`,
	"bg_dark_gray": `mediaCart_bg_dark_gray__4WPE+`,
	"mobileBookingWrapper": `mediaCart_mobileBookingWrapper__TZeom`,
	"mobileBooking": `mediaCart_mobileBooking__StUf7`,
	"bgMain": `mediaCart_bgMain__BhM07`,
	"progress": `mediaCart_progress__VqFXT`,
	"cartTitle": `mediaCart_cartTitle__2pZfi`,
	"cartWrapper": `mediaCart_cartWrapper__0mIij`,
	"w_114px": `mediaCart_w_114px__mNQBg`,
	"fs_9px": `mediaCart_fs_9px__GQUTv`,
	"fs_10px": `mediaCart_fs_10px__Uhcpp`,
	"fs_12px": `mediaCart_fs_12px__dkg78`,
	"fs_13px": `mediaCart_fs_13px__Qu3xL`,
	"pfs_22px": `mediaCart_pfs_22px__RKYJV`,
	"pfs_27px": `mediaCart_pfs_27px__qcAXP`,
	"gap_22px": `mediaCart_gap_22px__w6AYk`,
	"ppy_8px": `mediaCart_ppy_8px__d3Olo`,
	"pps_7px": `mediaCart_pps_7px__8Pf6X`,
	"ppt_9px": `mediaCart_ppt_9px__8PrYb`,
	"py_11px": `mediaCart_py_11px__orh4T`,
	"ppy_11_25px": `mediaCart_ppy_11_25px__hOUOC`,
	"ppy_12_5px": `mediaCart_ppy_12_5px__-3VLP`,
	"ppt_13px": `mediaCart_ppt_13px__2Nmhs`,
	"w_66px": `mediaCart_w_66px__N0CA-`,
	"w_77px": `mediaCart_w_77px__-C-cv`,
	"w_104px": `mediaCart_w_104px__28P2f`,
	"w_106px": `mediaCart_w_106px__1axy5`,
	"w_202px": `mediaCart_w_202px__eUll4`,
	"text_gray": `mediaCart_text_gray__J2xYb`,
	"new_line_pt1": `mediaCart_new_line_pt1__RAd64`,
	"new_line_pt2": `mediaCart_new_line_pt2__ncm4g`,
	"custom_select_arrow": `mediaCart_custom_select_arrow__NDeup`,
	"custom_date_arrow": `mediaCart_custom_date_arrow__Jbo8X`,
	"date_picker": `mediaCart_date_picker__HTW3z`,
	"date_picker_wrapper": `mediaCart_date_picker_wrapper__CRZMY`,
	"requestButton": `mediaCart_requestButton__x6tqr`,
	"mobileRequestButton": `mediaCart_mobileRequestButton__zNbaG`,
	"booking_text": `mediaCart_booking_text__iR1qT`,
	"booking_info": `mediaCart_booking_info__A0Ggt`,
	"requst_title": `mediaCart_requst_title__LbBZo`,
	"attached_plan_wrapper": `mediaCart_attached_plan_wrapper__azdIv`,
	"modal_list": `mediaCart_modal_list__XSpOM`,
	"media_icon": `mediaCart_media_icon__+m7FT`,
	"plan_gap": `mediaCart_plan_gap__Yuse9`,
	"plan_list_wrapper": `mediaCart_plan_list_wrapper__9eVxZ`,
	"plan_list": `mediaCart_plan_list__iD93P`,
	"booking_button_wrapper": `mediaCart_booking_button_wrapper__LoJox`,
	"attached_file_list": `mediaCart_attached_file_list__uFB2N`,
	"lh_170": `mediaCart_lh_170__FCqQc`,
	"cartTableWrapper": `mediaCart_cartTableWrapper__eu6zv`,
	"hover_underline": `mediaCart_hover_underline__BW23r`,
	"bookingCancel": `mediaCart_bookingCancel__zPjEJ`,
	"numericFormat": `mediaCart_numericFormat__NDlpE`,
	"mobileBookingButton": `mediaCart_mobileBookingButton__WIPFF`,
	"main_container": `mediaCart_main_container__OxKuY`,
	"selected_new_width": `mediaCart_selected_new_width__qnCIA`
};
export default ___CSS_LOADER_EXPORT___;
